// View: Menu
function view_menu(openCart = false) {
  var $ = jQuery;

  $("html").removeClass("is-reveal-open");

  $("#shopping-cart-view").foundation("close");
  charleys_show_loading();

  // Reroute if no location or cart is selected
  if (
    localStorage.getItem("charleys_customer_store_location_id") === null ||
    localStorage.getItem("charleys_customer_basket_id") === null
  ) {
    change_view("start-order");
    return;
  }

  // Show location menu
  $contentContainer
    .load(templateRoot + "wf-ordering-menu.html", function () {

      // var floatAddToCart = new Foundation.Sticky($('#floating-add-to-cart'));

      if (openCart && $('#shopping-cart-view').length) {
        $('#shopping-cart-view').foundation('open');
        $(".reveal-overlay").addClass('differnt-popup-overlay');
      } else {
        $(".reveal-overlay").removeClass('differnt-popup-overlay');
      }

      // Set Nutrition Document URL
      $('[data-nutrition-document]').attr('href', nutritionDocumentURL);

      // Product Detail Accordion
      new Foundation.Accordion($("#product-detail-accordion"), {});

      $("#hide-show-product-detail-accordion").click(function () {
        if ($("#product-detail-content").attr("aria-hidden") == "false") {
          $("[data-hide-detail-accordion]").addClass("hide");
          $("[data-show-detail-accordion]").removeClass("hide");
        } else {
          $("[data-hide-detail-accordion]").removeClass("hide");
          $("[data-show-detail-accordion]").addClass("hide");
        }
        $("#product-detail-accordion").foundation(
          "toggle",
          $("#product-detail-content")
        );
      });

      // Clear Reveals
      $(".product-detail-view, .start-new-order, .ingredient-modal").each(
        function () {
          if (typeof $(this).attr("aria-hidden") !== "undefined") {
            $(this).parent().remove();
          }
        }
      );

      var productOptionReveal = new Foundation.Reveal($("#product-detail-view"));
      var $startNewOrder = new Foundation.Reveal($("#start-new-order"));
      var ingredientReveal = new Foundation.Reveal($("#ingredient-modal"));

      // Set Up Product Option Reveal & Actions

      var $detailView = $("#product-detail-view");
      var $shippingCartView = $("#shopping-cart-view");
      // $("#start-new-order").parent().addClass('differnt-popup-overlay');
      // // $detailView.parent().scroll(productSelectScroll);
      // // $detailView.scroll(productSelectScroll);

      $detailView.on('open.zf.reveal', function (e) {
        $(".reveal-overlay").addClass('differnt-popup-overlay');
      });
      $detailView.on('closed.zf.reveal', function (e) {
        // console.log('menu modal closed', document.location.pathname + "#menu");
        // e.preventDefault();
        history.replaceState({}, '', '#menu');
        if (document.location.pathname === '/order/') {
          // console.log('no close');
        } else {
          $(".reveal-overlay").removeClass('differnt-popup-overlay');
        }
      });
      $shippingCartView.on('open.zf.reveal', function (e) {
        $(".reveal-overlay").addClass('differnt-popup-overlay');
      });
      $shippingCartView.on('closed.zf.reveal', function (e) {
        $(".reveal-overlay").removeClass('differnt-popup-overlay');
      });
      // function productSelectScroll() {
      //   // console.log('detail view scroll');
      //   // Sticky product option selections
      //   if ($("#floating-add-to-cart").length) {
      //     var distTop =
      //       $("#floating-add-to-cart").offset().top - $(window).scrollTop();
      //     // console.log(distTop);
      //
      //     $("#floating-add-to-cart>div").css({
      //       width: $("#floating-add-to-cart").outerWidth(),
      //     });
      //
      //     if (distTop <= 0) {
      //       $("#floating-add-to-cart").css({
      //         height: $("#floating-add-to-cart").outerHeight(),
      //       });
      //       $("#floating-add-to-cart").addClass("stuck");
      //     } else {
      //       $("#floating-add-to-cart").css({
      //         height: "auto",
      //       });
      //       $("#floating-add-to-cart").removeClass("stuck");
      //     }
      //   }
      // }

      var editBasketItem = 0,
        editBasketProduct = 0;
      if (window.location.hash.split("_").length > 1) {
        editBasketItem = Number(window.location.hash.split("_")[1]);
        editBasketProduct = Number(window.location.hash.split("_")[2]);
        // console.log("Edit Item: " + editBasketItem + ", " + editBasketProduct);
      }

      $("#product-item-qty").change(function () {
        calculateProductTotal();
      });

      $.when(
        olo_get_restaurant(
          localStorage.getItem("charleys_customer_store_location_id")
        )
      ).done(function (restaurant_data_json) {
        var restaurant_data = JSON.parse(restaurant_data_json);
        $("[data-menu-selected-store]").text(restaurant_data.name);

        restaurant_data.labels.forEach(function (label) {
          if (
            label.key ==
            "handoffmode_" +
            localStorage.getItem("charleys_customer_deliverymode")
          ) {
            $("[data-menu-handoff-mode]").text(label.value);
          }
        });

        var customer_schedule = localStorage.getItem(
          "charleys_customer_schedule"
        );
        if (customer_schedule !== "asap") {
          var scheduledTime = localStorage.getItem(
            "charleys_customer_scheduled_time"
          );

          // console.log(scheduledTime);

          if (scheduledTime.substring(0, 2) > 12) {
            scheduledTime =
              scheduledTime.substring(0, 2) -
              12 +
              scheduledTime.substring(2) +
              " PM";
          } else {
            scheduledTime = scheduledTime + " AM";
          }

          customer_schedule =
            "at " +
            scheduledTime +
            " on " +
            localStorage.getItem("charleys_customer_scheduled_day");
        } else {
          customer_schedule = customer_schedule.toUpperCase();
        }
        $("[data-menu-handoff-time]").text(customer_schedule);

        // show formatted store hours
        var hoursCalendar;
        var calendarMatched = false;

        // if there is a specific calendar of hours for this delivery type (e.g. dispatch), use it
        restaurant_data.calendar.every(function (calendar) {
          if (calendar.type == localStorage.getItem('charleys_customer_deliverymode')) {
            hoursCalendar = calendar;
            calendarMatched = true;
          }

          return !calendarMatched;
        });

        // otherwise use the regular business hours
        if (calendarMatched == false) {
          restaurant_data.calendar.every(function (calendar) {
            if (calendar.type == 'business') {
              hoursCalendar = calendar;
              calendarMatched = true;
            }

            return !calendarMatched;
          });
        }

        // format the stupid nonstandard olo dates
        var startDateRaw = hoursCalendar.ranges[0].start;
        var endDateRaw = hoursCalendar.ranges[0].end;

        var jsStartDate = new Date(startDateRaw.substring(0, 4), startDateRaw.substring(4, 6), startDateRaw.substring(6, 8), startDateRaw.substring(9, 11), startDateRaw.substring(12, 14), 0, 0);
        var jsEndDate = new Date(endDateRaw.substring(0, 4), endDateRaw.substring(4, 6), endDateRaw.substring(6, 8), endDateRaw.substring(9, 11), endDateRaw.substring(12, 14), 0, 0);

        var startTimeFormatted = jsStartDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
        var endTimeFormatted = jsEndDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });

        $('.store-hours').text('Hours ' + startTimeFormatted + ' - ' + endTimeFormatted);

        $('[data-store-info]').removeClass('hide');
      });

      // Start New Order (reset cart)
      $("#start-new-order-button").click(function () {
        charleys_show_loading();

        $.when(
          olo_create_basket(
            localStorage.getItem("charleys_customer_store_location_id"),
            false,
            true
          )
        ).done(function (ocb) {
          updateBasketDisplay();
          charleys_hide_loading();
        });
      });

      $("#edit-location").click(function () {
        change_view("start-order");
      });

      // Remove reveal modals
      $(
        "#account-select-order-type, #home-select-order-type",
        "#menu-select-order-type",
        "#location-detail-order-type"
      ).each(function () {
        if (typeof $(this).attr("aria-hidden") !== "undefined") {
          $(this).parent().remove();
        }
      });

      // Recreate reveal modals
      var $select_order_type_reveal = new Foundation.Reveal(
        $("#menu-select-order-type"),
        {}
      );

      $('input[name="menu-order-type"]').change(function () {
        clearLocationList();

        if ($('input[name="menu-order-type"]').val() !== "dispatch") {
          $("[data-search-deliver]").addClass("hide");
          $("#menu-order-location-search").addClass("hide");
          $(".fa-location-dot").addClass("hide");
          $("#menu-order-location-search-building").val("");
        } else {
          $("[data-search-deliver]").removeClass("hide");
          $("#menu-order-location-search").removeClass("hide");
          $(".fa-location-dot").removeClass("hide");
        }

        if ($("#menu-order-location-search").val()) {
          $("#menu-order-location-search-form").submit();
        } else {
          populate_user_restaurants("menu");
        }
      });

      // Hide/show schedule elements
      $('input[name="menu-order-schedule"]').change(function () {
        if ($('input[name="menu-order-schedule"]:checked').val() == "advance") {
          $("#menu-schedule-time").removeClass("hide");
        } else {
          $("#menu-schedule-time").addClass("hide");
        }
      });

      var todaysDate = new Date();
      var tomorrowsDate = new Date().addDays(1);
      var scheduleDates = getDates(todaysDate, new Date().addDays(45));
      var daysOfWeek = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      for (var i = 0; i < scheduleDates.length; i++) {
        var dayValue =
          scheduleDates[i].getFullYear() +
          "-" +
          zeroPad(scheduleDates[i].getMonth() + 1, 2) +
          "-" +
          zeroPad(scheduleDates[i].getDate(), 2);
        var dayLabel =
          daysOfWeek[scheduleDates[i].getDay()] +
          " " +
          (scheduleDates[i].getMonth() + 1) +
          "/" +
          scheduleDates[i].getDate();

        if (scheduleDates[i].getTime() === todaysDate.getTime()) {
          dayLabel = "Today";
        }
        if (scheduleDates[i].getTime() === tomorrowsDate.getTime()) {
          dayLabel = "Tomorrow";
        }

        $("[data-menu-order-time-wanted-day]").append(
          '<option value="' + dayValue + '">' + dayLabel + "</option>"
        );
      }

      var timeSelection = createQuarterHourIntervals();

      for (var ii = 0; ii < timeSelection.length; ii++) {
        $("[data-menu-order-time-wanted-time]").append(
          '<option value="' +
          convert12to24Hour(timeSelection[ii]) +
          '">' +
          timeSelection[ii] +
          "</option>"
        );
      }

      $("select#menu-time-wanted-day").change(function () {
        if (
          $(
            'select#menu-time-wanted-day option[value="' + $(this).val() + '"]'
          ).text() == "Today"
        ) {
          var currentTime = convert12to24Hour(formatAMPM(roundToNearest15()));
          // console.log(currentTime);
          $("select#menu-time-wanted-time-slot option").each(function () {
            if ($(this).val() < currentTime) {
              $(this).addClass("hide");
            }
            $("select#menu-time-wanted-time-slot").val(currentTime);
          });
        } else {
          $("select#menu-time-wanted-time-slot option").each(function () {
            $(this).removeClass("hide");
          });
        }
      });

      $("select#menu-time-wanted-day").trigger("change");

      // Autocomplete for location search
      if ($("#menu-order-location-search").length) {
        const inputD = $("#menu-order-location-search")[0];
        const options = {
          // componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry"],
          strictBounds: false,
          // types: ['(regions)'],
        };

        const autocompleteD = new google.maps.places.Autocomplete(
          inputD,
          options
        );
        autocompleteD.addListener("place_changed", function () {
          const place = autocompleteD.getPlace();
          if (place.geometry) {
            // ttmap.systemZoomChange = true;
            // getLocations(place.geometry.location.lat(), place.geometry.location.lng(), '', true);
            olo_get_nearby_locations(
              place.geometry.location.lat(),
              place.geometry.location.lng(),
              "",
              "menu"
            );
            // console.log(place);

            var components = {};
            $.each(place.address_components, function (k, v1) {
              $.each(v1.types, function (k2, v2) {
                components[v2] = v1.long_name;
              });
            });

            if (components.street_number && components.route) {
              $("#menu-order-location-search-streetaddress").val(
                components.street_number + " " + components.route
              );
            }

            if ('locality' in components) {
              $('#menu-order-location-search-city').val(components.locality);
            } else if ('administrative_area_level_2' in components) {
              $('#menu-order-location-search-city').val(components.administrative_area_level_2);
            }

            $("#menu-order-location-search-zipcode").val(
              components.postal_code
            );

            // console.log($('#order-location-search-streetaddress').val());
            // console.log($('#order-location-search-city').val());
            // console.log($('#order-location-search-zipcode').val());
          }
        });

        $("#menu-order-location-search-form").submit(function (e) {
          e.preventDefault();

          // console.log("search locations");

          $("#menu-order-location-search").blur();

          var address = $("#menu-order-location-search").val();
          var geocoder = new google.maps.Geocoder();

          if (address.length) {
            geocoder.geocode(
              {
                address: address,
              },
              function (results, status) {
                // console.log("GEOCODER STATUS ", status, results);
                if (status == google.maps.GeocoderStatus.OK) {
                  // console.log(results);

                  var components = {};
                  $.each(results[0].address_components, function (k, v1) {
                    $.each(v1.types, function (k2, v2) {
                      components[v2] = v1.long_name;
                    });
                  });

                  // console.log('address components', components);

                  if (components.street_number && components.route) {
                    $("#menu-order-location-search-streetaddress").val(
                      components.street_number + " " + components.route
                    );
                  }

                  if ('locality' in components) {
                    $('#menu-order-location-search-city').val(components.locality);
                  } else if ('administrative_area_level_2' in components) {
                    $('#menu-order-location-search-city').val(components.administrative_area_level_2);
                  }

                  $("#menu-order-location-search-zipcode").val(
                    components.postal_code
                  );

                  olo_get_nearby_locations(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng(),
                    "",
                    "menu"
                  );
                } else {
                  $("#menu-order-location-search").val("");
                  charleys_hide_loading();
                }
              }
            );
          } else {
            charleys_hide_loading();
          }
        });
        // initMap();
      }

      $("#menu-select-order-type-button").click(function () {
        var validAddress = true;
        var isDelivery = Boolean(
          $('input[name="menu-order-type"]').val() == "dispatch"
        );

        // Delivery requires a full address, thus fails validation if no street address is present
        if (
          isDelivery &&
          !$("#menu-order-location-search-streetaddress").val().length
        ) {
          validAddress = false;
        }

        $("#menu-order-location-search").removeClass("form-alert");
        $("#menu-order-location-search-error").addClass("hide");

        if (validAddress) {
          charleys_show_loading();
          setAddressComponents("menu");

          $.when(olo_set_basket_settings("menu")).done(function (osbs_json) {
            // Go to the restaurant menu
            var osbs = JSON.parse(osbs_json);
            // console.log(osbs);
            // Display basket setting errors
            // Dispatch address
            if ("dispatchaddress" in osbs && "code" in osbs.dispatchaddress) {
              $("[data-delivery-error]").text(osbs.dispatchaddress.message);
              $("#menu-order-location-search-error-delivery").removeClass(
                "hide"
              );
              clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
              charleys_hide_loading();
              // Time wanted
            } else if ("timewanted" in osbs && "code" in osbs.timewanted) {
              $("[data-delivery-error]").text(osbs.timewanted.message);
              $("#menu-order-location-search-error-delivery").removeClass(
                "hide"
              );
              clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
              charleys_hide_loading();
              // Delivery mode
            } else if ("deliverymode" in osbs && "code" in osbs.deliverymode) {
              $("[data-delivery-error]").text(osbs.deliverymode.message);
              $("#menu-order-location-search-error-delivery").removeClass(
                "hide"
              );
              clearBasketSession(); // Remove the cart session to prevent menu selection and checkout
              charleys_hide_loading();
              // Otherwise, good to proceed
            } else {
              updateBasketDisplay();
              if ($("#home-select-order-type").length) {
                $("#home-select-order-type").foundation("close");
              }
              if ($("#account-select-order-type").length) {
                $("#account-select-order-type").foundation("close");
              }
              if ($("#location-detail-select-order-type").length) {
                $("#location-detail-select-order-type").foundation("close");
              }
              charleys_hide_loading();
              window.location.reload();
            }
          });
        } else {
          $("#menu-order-location-search").addClass("form-alert");
          $("#menu-order-location-search-error").removeClass("hide");
        }
      });

      $("#edit-handoff").click(function () {
        window.scrollTo(0, 0);
        $("#menu-select-order-type").foundation("open");
      });

      // Get Menu and Set Up Selections
      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "get_olo_get_menu",
          restaurant_id: localStorage.getItem(
            "charleys_customer_store_location_id"
          ),
        },
        success: function (response) {
          // console.log(JSON.parse(response)); 

          var menu = JSON.parse(response);
          //menu category 
          let readOnlyCategoryMenuItemCarryOver = localStorage.getItem('readOnlyCategoryMenuItemCarryOver');
          if (readOnlyCategoryMenuItemCarryOver) {
            readOnlyCategoryMenuItemCarryOver = readOnlyCategoryMenuItemCarryOver.toLowerCase();
          }
          let readOnlyCategoryMenuItemCarryOverImg = localStorage.getItem('readOnlyCategoryMenuItemCarryOverImg');

          //menu item
          let readOnlyMenuItemCarryOver = localStorage.getItem('readOnlyMenuItemCarryOver');
          // console.log('readOnlyMenuItemCarryOver', readOnlyMenuItemCarryOver);
          if (readOnlyMenuItemCarryOver) {
            readOnlyMenuItemCarryOver = readOnlyMenuItemCarryOver.toLowerCase();
          }
          let readOnlyMenuItemCarryOverImg = localStorage.getItem('readOnlyMenuItemCarryOverImg');

          let matchFound = false;
          let matchProductID = null;
          // populate fave/recent order callout
          var callout_products = [];
          var recents_complete = false;
          var faves_complete = false;

          if (isUserLoggedIn(true)) {
            $("[data-menu-fave-callout]").removeClass("hide");
          }

          // create menu categories and single use categories
          function createMenuCategories(index, menu_cat) {
            //read only menu filter
            const normalize = (str) => str.replace(/–/g, '-').replace(/—/g, '-'); // Replace en dash and em dash with hyphen
            const sanitize = (str) => normalize(str.replace(/\s+/g, ' ').trim()); // Normalize and sanitize the string
            if (readOnlyCategoryMenuItemCarryOver &&
              sanitize(menu_cat.name.toLowerCase()) === sanitize(readOnlyCategoryMenuItemCarryOver.toLowerCase())) {
              // console.log('Matching product:', menu_cat.name, menu_cat.id);
              matchFound = true;
              matchProductID = menu_cat.id;
            }
            // console.log(sanitize(menu_cat.name.toLowerCase()), matchFound, sanitize(readOnlyCategoryMenuItemCarryOver.toLowerCase()));

            //end read only menu filter
            var $cat_template = $(
              "[data-category-selector-template].hide"
            ).clone();
            if (menu_cat.name === 'CHOOSE FROM THE FOLLOWING:') {
              $cat_template.addClass('singleUseTemplate').addClass('option-hide');
            }
            $cat_template.find('input[type="radio"]').attr("id", menu_cat.id);
            $cat_template
              .find('input[type="radio"]')
              .attr("value", menu_cat.id);
            $cat_template.find("label").attr("for", menu_cat.id);
            $cat_template.find("label [data-label-name]").text(menu_cat.name);

            // Category Images
            var menuCatImage = '',
              menuCatImageAlt = menu_cat.name;

            if (menu.imagepath && menu_cat.images) {
              if (menu.imagepath && menu_cat.images.find((image) => image.groupname === "mobile-webapp-menu")) {
                menuCatImage = menu.imagepath + menu_cat.images.find((image) => image.groupname === "mobile-webapp-menu").filename;
                // Set alt if description exists
                if (menu_cat.images.find((image) => image.groupname === "mobile-webapp-menu").description) {
                  menuCatImageAlt = menu_cat.images.find((image) => image.groupname === "mobile-webapp-menu").description;
                }
              }
            }

            if (menuCatImage.length == 0) {
              if (menu_cat.image_url) {
                menuCatImage = menu_cat.image_url;
              }
            }

            // No image associated -- Show Placeholder
            if (menuCatImage.length == 0) {
              menuCatImage = "https://www.charleys.com/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg";
            }

            $cat_template.find("img").attr("src", menuCatImage);
            $cat_template.find("img").attr("alt", menuCatImageAlt);

            $cat_template.removeClass("hide");

            $(".category-selector-wrap").append($cat_template);

            var $menu_category = $(
              "[data-menu-category-template].hide"
            ).clone();

            $menu_category.attr("data-category-id", menu_cat.id);

            $menu_category.find("[data-category-title]").text(menu_cat.name);
            $menu_category
              .find("[data-category-desc]")
              .text(menu_cat.description);

            // Display Menu Category Filter
            $.each(menu_cat.products, function (index, menu_item) {
              // console.log('menu_item', menu_item);
              //read only menu filter              
              if (menu_item.name.toLowerCase() === readOnlyMenuItemCarryOver) {
                // console.log('Matching product:', menu_item.name, menu_item.id, menu_cat.id);
                matchFound = true;  // Set flag to true if a match is found
                matchProductID = menu_item.id;
              }
              //end read only menu filter

              var $menu_category_item = $(
                "[data-menu-item-template].hide"
              ).clone();

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-id", menu_item.id);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-chain-id", menu_item.chainproductid);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-selection-cost", menu_item.cost);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-minimum-quantity", menu_item.minimumquantity);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-maximum-quantity", menu_item.maximumquantity);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-quantity-increment", menu_item.quantityincrement);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-availability-now", menu_item.availability.now);
              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr(
                  "data-availability-isdisabled",
                  menu_item.availability.isdisabled
                );

              // console.log(menu_item);

              // Disable if unavailable for current delivery method
              if (
                menu_item.unavailablehandoffmodes.includes(
                  localStorage.getItem("charleys_customer_schedule")
                )
              ) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              // Disable if not available now
              if (!menu_item.availability.now) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              // Disabled if 86ed
              if (menu_item.availability.isdisabled) {
                $menu_category_item
                  .find("[data-menu-selection-id]")
                  .prop("disabled", true);
              }

              var menuImage = "";
              var menuImageDetail = "";

              if (menu.imagepath && menu_item.imagefilename) {
                menuImage = menu.imagepath + menu_item.imagefilename;
                if (
                  menu.imagepath &&
                  menu_item.images.find(
                    (image) => image.groupname === "mobile-webapp-customize"
                  )
                ) {
                  menuImageDetail =
                    menu.imagepath +
                    menu_item.images.find(
                      (image) => image.groupname === "mobile-webapp-customize"
                    ).filename;
                } else {
                  menuImageDetail = menuImage;
                }
              }
              else {
                // No image associated -- Show Placeholder
                menuImage =
                  "https://www.charleys.com/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg";
                menuImageDetail = menuImage;
              }

              $menu_category_item.find("img").attr("src", menuImage);

              $menu_category_item
                .find("[data-menu-selection-id]")
                .attr("data-menu-image-url", menuImageDetail);

              $menu_category_item
                .find("img")
                .attr("alt", menu_item.name);

              $menu_category_item
                .find("[data-menu-item-title]")
                .text(menu_item.name);

              $menu_category_item
                .find("[data-menu-item-calories]")
                .text(menu_item.basecalories);

              $menu_category_item
                .find("[data-menu-item-desc]")
                .text(menu_item.description);

              if (menu_item.cost !== 0) {
                $menu_category_item
                  .find("[data-menu-item-price]")
                  .text("$ " + formatMoney(menu_item.cost));
              } else {
                $menu_category_item
                  .find("[data-menu-item-price]")
                  .addClass("hide");
              }

              var calories = "";
              if (menu_item.basecalories !== null) {
                calories = menu_item.basecalories;
              }
              if (menu_item.maxcalories !== null) {
                if (calories.length) {
                  calories += " " + menu_item.caloriesseparator + " ";
                }
                calories += menu_item.maxcalories;
              }

              if (calories.length) {
                calories += " Cal";
              }

              $menu_category_item
                .find("[data-menu-item-calories]")
                .text(calories);

              $menu_category_item.removeClass("hide");
              $menu_category.append($menu_category_item);
            });

            if (menu_cat.products.length > 0) {
              $menu_category.find("[data-menu-item-template].hide").remove();
              $menu_category.removeClass("hide");
              $(".wf-ordering-menu .menu-grid").append($menu_category);
            }
          }
          $.each(menu.categories, function (index, menu_cat) {
            createMenuCategories(index, menu_cat)
          }); // $.each(menu.categories
          $.each(menu.singleusecategories, function (index, menu_cat) {
            createMenuCategories(index, menu_cat);
            // $cat_template.addClass('option-hide');
          }); // $.each(menu.categories

          // Back Button Default
          $defaultBackAction = true;
          if ($('.reveal-overlay [data-back-button]').length > 0) {
            $defaultBackAction = false;
          }
          $backBtn = $(".wf-ordering-container [data-back-button]");
          $backBtn.click(function () {
            if ($defaultBackAction) {
              change_view('start-order');
            }
          });
          // Filter Categories
          function onCategoryChange($radioInput) {
            $('html, body').animate({ scrollTop: 0 }, 'fast', function () {
              // console.log("I scrolled up");
            });
            // console.log($($radioInput).val());

            if ($($radioInput).val() == "all") {
              // console.log('#1');
              $("[data-menu-category-template]:not(.hide)").removeClass(
                "option-hide"
              );
            } else {
              // console.log('#2');

              $("[data-menu-category-template]:not(.hide)").addClass(
                "option-hide"
              );
              var showID = $(
                '[data-category-selector-template]:not(.hide) input[type="radio"]:checked'
              ).val();
              $(
                '[data-menu-category-template][data-category-id="' +
                showID +
                '"]'
              ).removeClass("option-hide");

              //show menu, hide category options, change back button
              $(".menu-grid").removeClass(
                "option-hide"
              );
              $(".category-selector, [data-category-selector-template]:not(.hide), .wf-ordering-menu .heading").addClass(
                "option-hide"
              );

              $backBtn.find("[data-button-label]").html("Back");

              $defaultBackAction = false;

              $backBtn.click(function () {
                $(
                  '[data-category-selector-template]:not(.hide) input[type="radio"]'
                ).prop("checked", false);
                $(
                  "[data-category-selector-template]:not(.hide), .wf-ordering-menu .heading"
                ).removeClass("option-hide");
                $("[data-menu-category-template]:not(.hide)").removeClass(
                  "option-hide"
                );
                $(".category-selector").removeClass("option-hide");
                $(".category-selector").removeClass("option-hide");
                $(".menu-grid").addClass("option-hide");
                $("[data-back-button] [data-button-label]").html("Back");
                $defaultBackAction = true;
              });
            }
          }
          $('[data-category-selector-template]:not(.hide) input[type="radio"]').change(function () {
            onCategoryChange($(this));
          });

          // Open Menu Item
          $("button.menu-item-selector").click(function () {
            charleys_show_loading();

            // Preflight: set all qty values
            $("#product-item-qty").val("1");
            $("#product-item-qty").attr("min", "1");
            $("#product-item-qty").attr("max", "99");
            $("#product-item-qty").attr("step", "1");

            // Preflight: set ids to be used
            var productId = $(this).attr("data-menu-selection-id");
            var chainProductId = $(this).attr("data-menu-selection-chain-id");
            var productCost = $(this).attr("data-menu-selection-cost");

            // Preflight: set min/max/increment for qty selector
            var productMinQty = $(this).attr("data-minimum-quantity");
            var productMaxQty = $(this).attr("data-maximum-quantity");
            var productIncrement = $(this).attr("data-quantity-increment");

            if (productMinQty) {
              $("#product-item-qty").attr("min", productMinQty);
              $("#product-item-qty").val(productMinQty);
            }
            if (productMaxQty) {
              $("#product-item-qty").attr("max", productMaxQty);
              // console.log('i small boy', productMaxQty);
            }
            if (productIncrement) {
              $("#product-item-qty").attr("step", productIncrement);
            }

            // Preflight: set qty element
            setQuantityElem(
              $("#product-quantity-selector"),
              $("#product-item-qty").attr("min"),
              $("#product-item-qty").attr("max"),
              $("#product-item-qty").attr("step")
            );

            $("[data-menu-item-detail-image]").attr(
              "src",
              $(this).attr("data-menu-image-url")
            );

            //look for image in image array with group name 'web detail' for product details header image
            // if (menu.imagepath && menu_item.images.find(image => image.groupname === 'web-detail')) {
            //   $('[data-menu-item-detail-image]').attr('src', menu.imagepath + menu_item.images.find(image => image.groupname === 'web-detail').filename);
            // } else {
            //   // No image associated -- Show Placeholder
            //   $('[data-menu-item-detail-image]').attr('src', '/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg');
            // }

            $detailView
              .find("[data-product-view-title]")
              .text($(this).find("[data-menu-item-title]").text());

            $detailView
              .find("[data-product-total-calories]")
              .text($(this).find("[data-menu-item-calories]").text());
            // Set the text from data-menu-item-desc to data-product-view-description
            let menuItemDesc = $(this).find("[data-menu-item-desc]").text();
            $detailView.find("[data-product-view-description]").text(menuItemDesc);

            // Check if data-menu-item-desc has no text and hide the element if necessary
            if ($.trim(menuItemDesc) === "") {
              // Add class 'hide' to data-main-ingredients-with-no-custumization if there is no text
              $detailView.find("[data-main-ingredients-with-no-custumization]").css('display', 'none');
            } else {
              // Remove the 'hide' class if there's text, in case you want to toggle it
              $detailView.find("[data-main-ingredients-with-no-custumization]").css('display', 'block');
            }

            $detailView
              .find("#item-add-to-cart")
              .attr("data-menu-selection-id", productId);
            $detailView
              .find("#item-add-to-cart")
              .attr("data-menu-selection-chain-id", chainProductId);
            //hide quantiy if max quanitiy is 1 
            // console.log('Maximum quantity:', $(this).attr('data-maximum-quantity'));
            if (Number($(this).attr('data-maximum-quantity')) === 1) {
              $('.add-to-cart-qty').addClass('hide');
            } else {
              $('.add-to-cart-qty').removeClass('hide');
            }
            //end
            var $basePrice = $detailView.find("[data-base-price]");

            $basePrice.find('input[type="checkbox"]').attr("id", productId);
            $basePrice.find('input[type="checkbox"]').attr("data-cost", productCost);
            $basePrice.find('input[type="checkbox"]').attr("chainproductid", chainProductId);
            // $basePrice.find('input[type="checkbox"]').val(productCost);
            $basePrice.find("label").attr("for", productId);
            $basePrice
              .find("label")
              .text(
                $(this).find("[data-menu-item-title]").text() + " Base Price"
              );

            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "get_olo_get_menu_options",
                productId: productId,
              },
              success: function (response) {
                // console.log('menu', JSON.parse(response));

                // console.log("load product options");

                clearProductOptions();

                var optionGroups = JSON.parse(response).optiongroups;

                var $productDetails = $("#product-detail-view");


                $.each(optionGroups, function (index, group) {
                  setItemOptions(group);
                }); // $.each(optionGroups ...

                calculateProductTotal();

                // Product Option / Modifier UI
                $("[data-product-option-group]").each(function () {
                  $(this)
                    .find(
                      "input[data-item-selector], input[data-item-selector-modifier], input.qtyinput"
                    )
                    .change(function () {

                      // Validate Form
                      let $inputElementForComboMeal = $('fieldset.highlight span:nth-of-type(2) input');
                      let $inputElementForNotComboMeal = $('fieldset.highlight span:nth-of-type(3) input');
                      let inputChanged = $(this);

                      if ($(this).is($inputElementForComboMeal) || $(this).is($inputElementForNotComboMeal)) {
                        // Pass comboChange as true
                        // console.log('ahhh', $(this)); 
                        validateItemForm(true, $(this));
                      } else {
                        // Pass comboChange as false
                        validateItemForm(false, $(this));
                        // console.log('ahhh!', $(this));

                      }
                      // Calculate Total
                      calculateProductTotal();
                    });
                });

                // If the product is being viewed in edit mode
                if (editBasketItem) {
                  charleys_show_loading();

                  $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: {
                      action: "olo_get_basket",
                      basketGuid: localStorage.getItem(
                        "charleys_customer_basket_id"
                      ),
                    },
                    success: function (response) {
                      // console.log(response);
                      // console.log(JSON.parse(response));
                      var result = JSON.parse(response);

                      var basketProducts = result.products;

                      $.each(basketProducts, function (key, bProduct) {
                        if (bProduct.id == editBasketItem) {
                          $.each(bProduct.choices, function (key, choice) {
                            // Select products
                            $("#" + choice.optionid).click();
                            $("#" + choice.optionid).prop('checked', true);
                            // console.log('choice.optionid', choice.optionid, choice.name);

                            // Set quantities
                            $(
                              'input[type="radio"][data-qty-for="' +
                              choice.optionid +
                              '"][value="' +
                              choice.quantity +
                              '"]'
                            ).click();
                            $(
                              'input[type="number"][data-qty-for="' +
                              choice.optionid +
                              '"]'
                            )
                              .val(choice.quantity)
                              .change();

                          });
                          // Set customer Name
                          $("#item-customer-name").val(bProduct.recipient);
                          // Set Quantity
                          $("#product-item-qty")
                            .val(bProduct.quantity)
                            .change();
                          return;
                        }
                      });

                      $detailView
                        .find("#item-add-to-cart-update")
                        .attr("data-update-product-id", editBasketItem);
                      // $detailView.find('#item-add-to-cart-update').attr('data-update-product-id', productId);

                      $detailView.find("#item-add-to-cart").addClass("hide");
                      $detailView
                        .find("#item-add-to-cart-update")
                        .removeClass("hide");

                      charleys_hide_loading();
                      //scroll to combo info 
                      if (localStorage.getItem('scrollToComboModifier') === 'true') {
                        // console.log('Scroll flag is set. Trying to scroll...');
                        $('fieldset.highlight').each(function () {
                          let $fieldset = $(this);
                          let $inputElement = $fieldset.find('span:nth-of-type(2) input');
                          $inputElement.prop('checked', true);
                        });

                        // let productChoices = JSON.parse(localStorage.getItem('scrollToComboModifierOptions'));
                        // Find the object with name 'No'
                        // const noChoice = productChoices.find(choice => choice.name.toLowerCase() === 'small');
                        // if (noChoice) {
                        //   console.log('no Choice', noChoice.optionid);  

                        //   // Find the input element with ID matching noChoice.optionid
                        //   const $inputElement = $("#" + noChoice.optionid);
                        //   console.log('sdgsdgs', $inputElement.parent().parent().find('legend'))

                        // }


                        // $('fieldset.size-selector').each(function () {
                        //   let $fieldset = $(this);
                        //   let $inputElement = $fieldset.find('span:nth-of-type(3) input');
                        //   $inputElement.prop('checked', true);
                        // }); 
                        // Remove the flag from localStorage after scrolling
                        validateItemForm(true);
                        localStorage.removeItem('scrollToComboModifier');
                      }

                      //end of scroll to combo info 
                      // Reset URL to prevent backout collisions
                      history.replaceState({}, "", "#menu-product-view");
                      editBasketItem = 0;
                    },
                    complete: function () { },
                  });
                } else {
                  $detailView.find("#item-add-to-cart").removeClass("hide");
                  $detailView.find("#item-add-to-cart-update").addClass("hide");
                }

                $("[data-info]").off("click");
                $("[data-info]").on("click", function () {
                  var $ingredientModal = $("#ingredient-modal");

                  $ingredientModal
                    .find("[data-modal-cover]")
                    .addClass("covered");

                  // GET INGREDIENT DATA, LOAD IT INTO INGREDIENT MODAL
                  // get_wp_ingredient_data
                  charleys_show_loading();

                  $.ajax({
                    type: "POST",
                    url: ajax_url,
                    data: {
                      action: "get_wp_ingredient_data",
                      post_id: $(this).attr("data-ingredient-id"),
                    },
                    success: function (response) {
                      var result = JSON.parse(response);

                      if (result.image_url.length) {
                        $("#ingredient-modal")
                          .find("img[data-main-image]")
                          .attr("src", result.image_url);
                      } else {
                        $("#ingredient-modal")
                          .find("img[data-main-image]")
                          .attr(
                            "src",
                            "https://www.charleys.com/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg"
                          );
                      }

                      $("#ingredient-modal")
                        .find("img[data-main-image]")
                        .attr("alt", result.title);
                      $("#ingredient-modal")
                        .find("[data-ingredient-title]")
                        .text(result.title);
                      $("#ingredient-modal")
                        .find("[data-calories]")
                        .text(result.calories);
                      $("#ingredient-modal")
                        .find("[data-ingredient-info]")
                        .html(result.info);

                      $("#ingredient-modal").find("[data-spicy]").empty();
                      if (
                        "spicy" in result &&
                        result.spicy !== "0" &&
                        result.spicy !== null
                      ) {
                        var labelText = "";
                        for (i = 0; i < Number(result.spicy); i++) {
                          labelText += '<i class="fa-solid fa-pepper-hot"></i>';
                        }
                        for (i = Number(result.spicy); i < 5; i++) {
                          labelText +=
                            '<i class="fa-solid fa-pepper-hot gray"></i>';
                        }
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .attr("data-spicy", result.spicy);
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .attr(
                            "aria-label",
                            "Spicy Level is " + result.spicy + " out of 5"
                          );
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .attr(
                            "title",
                            "Spicy Level is " + result.spicy + " out of 5"
                          );
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .append(labelText);
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .removeClass("hide");
                      } else {
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .addClass("hide");
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .attr("data-spicy", 0);
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .removeAttr("aria-label");
                        $("#ingredient-modal")
                          .find("[data-spicy]")
                          .removeAttr("title");
                      }

                      $ingredientModal
                        .find("[data-modal-cover]")
                        .removeClass("covered");
                      $ingredientModal.foundation("open");

                      charleys_hide_loading();
                    },
                  });
                });
              },
              complete: function () {
                if (!editBasketItem) {
                  charleys_hide_loading();
                }
                $detailView.foundation("open");
                // console.log('open product view');

                $('#product-detail-view').animate({ scrollTop: 0 }, 500); // Scroll to top
                // $detailView.find('.product-detail-view-wrap').css({
                //   'padding-bottom': $('#floating-add-to-cart').outerHeight()
                // });

                // Add a layer in history to allow back button to close modal
                if (window.location.hash !== "#menu-product-view" && editBasketItem == 0) {
                  history.pushState({}, "", "#menu-product-view");
                }
                //select defualt options 
                $(
                  "[data-product-options] input[data-item-selector], [data-modifier-group] input[data-item-selector-modifier], [combo-side-selection-customizer-information-popup] input[data-item-selector-modifier], [combo-drink-selection-customizer-information-popup] input[data-item-selector-modifier], [main-ingredient-customizer-information-popup] input[data-item-selector-modifier]"
                ).each(function () {
                  if ($(this).attr('radiodefualtcheckedstate') === 'true') {
                    if ($(this).is($('[main-ingredient-customizer-information-popup] input[data-item-selector-modifier]'))) {
                      // console.log($(this), 'hjfjhf'); 
                    }
                    $(this).prop('checked', true);
                    $(this).parent().addClass("selected");
                  }
                });
                validateItemForm();
                calculateProductTotal();
                // //check defualt 'regular' menu items
                // if ($('strong.defualtCheckedState').length > 0) {
                //   let $inputElement = $('strong.defualtCheckedState').closest('span[data-product-option]').find('input');
                //   $inputElement.prop('checked', true);
                //   calculateProductTotal();
                // }
                // if ($('fieldset.highlight').length > 0) {
                //   let $inputElement = $('fieldset.highlight span:nth-of-type(3) input');
                //   $inputElement.prop('checked', true);

                //   calculateProductTotal();
                //   validateItemForm();
                // }
                //end of check defualt 'regular' menu items
                // combo popup alert JS functionality
                // if ($('.product-detail-view-wrap.show-combo-popup-alert') && (localStorage.getItem('scrollToComboModifier') === 'true')) {
                //   console.log('asdgadsg')
                //   $('.combo-popup-alert').addClass('hide');
                // }
                // if ($('.product-detail-view-wrap.show-combo-popup-alert')) {
                //   let notAddComboButton = $('#combo-popup-alert-not-add-combo');
                //   let comboField = $('fieldset.product-modifier.highlight:not(.hide):not(.option-hide)>span>label');
                //   let addComboButton = $('#combo-popup-alert-add-combo');
                //   let closeComboButtonTwo = $('#close-combo-popup-alert-two');
                //   let sizeOptions = $('[data-product-options].size-selector:not(.hide)');
                //   let addComboButtonClicked = false;
                //   $('.first-screen').removeClass('hide');
                //   $('.second-screen.yes-option').addClass('hide');

                //   // console.log('comboField', comboField); 
                //   // //no combo
                //   if (notAddComboButton.length) {
                //     const hideComboAlert = () => {
                //       $('.combo-popup-alert').addClass('hide');
                //       $('.product-detail-view-wrap').removeClass('show-combo-popup-alert');
                //     };

                //     notAddComboButton.on('click', hideComboAlert);
                //     comboField.on('click', hideComboAlert);
                //   }

                //   //yes combo
                //   function updateComboRadioButtons() {
                //     $('fieldset.highlight').each(function () {
                //       let $fieldset = $(this);
                //       let $inputElement = $fieldset.find('span:nth-of-type(2) input');
                //       $inputElement.prop('checked', true);
                //     });
                //     calculateProductTotal();
                //     validateItemForm();
                //   }
                //   if (addComboButton.length) {
                //     addComboButton.on('click', function () {
                //       $('.first-screen').addClass('hide');
                //       $('.second-screen.yes-option').removeClass('hide');
                //       updateComboRadioButtons();
                //       addComboButtonClicked = true;
                //       setTimeout(function () {
                //         $('.combo-popup-alert').addClass('hide');
                //         $('.product-detail-view-wrap').removeClass('show-combo-popup-alert');
                //       }, 3500); // 4000 milliseconds
                //     });
                //     if (sizeOptions) {
                //       sizeOptions.on('click', function () {
                //         if (addComboButtonClicked) {
                //           updateComboRadioButtons();
                //         } else {
                //           let $inputElement = $('fieldset.highlight span:nth-of-type(3) input');
                //           $inputElement.prop('checked', true);

                //           calculateProductTotal();
                //           validateItemForm();
                //         }
                //       });
                //     }

                //   }
                //   if (closeComboButtonTwo.length) {
                //     closeComboButtonTwo.on('click', function () {
                //       $('.combo-popup-alert').addClass('hide');
                //       $('.product-detail-view-wrap').removeClass('show-combo-popup-alert');
                //     });

                //   }
                // }

                //end of combo popup alert JS functionality
                // undoConditionFormattingChanges when click back button
                $(document).on('click', '[data-button-label]', function () {
                  // console.log('back button clicked');
                  $('.wf-ordering-menu').removeClass('hides');
                  $('#main-ingredient-customizer-information-parent').removeAttr('style').addClass('hide');
                  undoConditionFormattingChanges();
                });
                function undoConditionFormattingChanges() {
                  let $comboMealFormattingSelector = $('.right-col.combo-meal');
                  if ($comboMealFormattingSelector.length) {
                    $comboMealFormattingSelector.removeClass('combo-meal');
                  }
                  let $drinkAddonFormattingSelector = $('.right-col.formatting-classic-combo-drink-addon');
                  if ($drinkAddonFormattingSelector.length) {
                    $drinkAddonFormattingSelector.removeClass('formatting-classic-combo-drink-addon');
                  }
                  let $addAccordianConditionalFormattingSelector = $('.right-col.formatting-add-accordian');
                  if ($addAccordianConditionalFormattingSelector.length) {
                    $addAccordianConditionalFormattingSelector.removeClass('formatting-add-accordian');
                  }
                  let $bigGameBundleComboConditionalFormattingSelector = $('.right-col.formatting-big-game-bundle');
                  if ($bigGameBundleComboConditionalFormattingSelector.length) {
                    $bigGameBundleComboConditionalFormattingSelector.removeClass('formatting-big-game-bundle');
                  }
                  let $classicComboConditionalFormattingSelectorWings = $('.right-col.formatting-classic-combo-wings');
                  if ($classicComboConditionalFormattingSelectorWings.length) {
                    $classicComboConditionalFormattingSelectorWings.removeClass('formatting-classic-combo-wings');
                  }
                  let $classicComboConditionalFormattingSelectorDrinkAddon = $('.right-col.formatting-classic-combo-drink-addon');
                  if ($classicComboConditionalFormattingSelectorDrinkAddon.length) {
                    $classicComboConditionalFormattingSelectorDrinkAddon.removeClass('formatting-classic-combo-drink-addon');
                  }
                  let $classicComboConditionalFormattingSelectorCheesesteak = $('.right-col.formatting-classic-combo-cheesesteak');
                  if ($classicComboConditionalFormattingSelectorCheesesteak.length) {
                    $classicComboConditionalFormattingSelectorCheesesteak.removeClass('formatting-classic-combo-cheesesteak');
                  }
                  let $classicComboConditionalFormattingSelector = $('.right-col.formatting-classic-combo');
                  if ($classicComboConditionalFormattingSelector.length) {
                    $classicComboConditionalFormattingSelector.removeClass('formatting-classic-combo');
                  }

                  let $wingsConditionalFormattingSelector = $('.right-col.formatting-30-50-pc-wings');
                  let $wingsConditionalFormattingSelectorForS = $('.right-col.formatting-30-50-pc-wings-with-s');
                  if ($wingsConditionalFormattingSelector.length) {
                    $wingsConditionalFormattingSelector.removeClass('formatting-30-50-pc-wings');
                  }
                  if ($wingsConditionalFormattingSelectorForS.length) {
                    $wingsConditionalFormattingSelector.removeClass('formatting-30-50-pc-wings-with-s');
                  }

                  // let $comboConditionalFormattingSelector = $('.product-detail-view-wrap.show-combo-popup-alert');
                  // if ($comboConditionalFormattingSelector.length) {
                  //   $comboConditionalFormattingSelector.removeClass('show-combo-popup-alert');
                  // }
                }



                validateItemForm();

              },
            });
          }); // $('button.menu-item-selector').click
          //read only menu forwarding 
          if (!matchFound && readOnlyMenuItemCarryOver || !matchFound && readOnlyCategoryMenuItemCarryOver) {
            // console.log('No match on any--display location disclaimer');

            $('#read-only-menu-disclaimer').removeClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'false');
            if (readOnlyCategoryMenuItemCarryOver) {
              $('#read-only-menu-disclaimer img').attr('src', readOnlyCategoryMenuItemCarryOverImg);
              $('#read-only-menu-disclaimer img').attr('alt', readOnlyCategoryMenuItemCarryOver);
            } else {
              $('#read-only-menu-disclaimer img').attr('src', readOnlyMenuItemCarryOverImg);
              $('#read-only-menu-disclaimer img').attr('alt', readOnlyMenuItemCarryOver);
            }

            //close
            $(document).keydown(function (event) {
              if (event.key === "Escape") {
                $('#read-only-menu-disclaimer').addClass('hide');
              }
            });
            $(document).click(function (event) {
              // Check if the click target is outside of the .content div
              if (!$(event.target).closest('#read-only-menu-disclaimer .content').length) {
                $('#read-only-menu-disclaimer').addClass('hide');
              }
            });
            $('#viewMenu').click(function () {
              $('#read-only-menu-disclaimer').addClass('hide');
            });

          } else if (readOnlyMenuItemCarryOver) {
            $('.wf-ordering-menu').addClass('hides');

            charleys_show_overloading();

            $('#read-only-menu-disclaimer').addClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'true');
            let $button = $(`[data-menu-selection-id="${matchProductID}"]`);

            if ($button.length) {
              $button.click();
              localStorage.removeItem('readOnlyMenuItemCarryOver');
              localStorage.removeItem('readOnlyMenuItemCarryOverImg');
              setTimeout(function () {
                charleys_hide_overloading();
              }, 500);
            }
          } else if (readOnlyCategoryMenuItemCarryOver) {
            charleys_show_overloading();

            $('#read-only-menu-disclaimer').addClass('hide');
            $('#read-only-menu-disclaimer').attr('aria-hidden', 'true');

            let $label = $(`label[for="${matchProductID}"]`);
            if ($label.length) {
              $label.click();
              localStorage.removeItem('readOnlyCategoryMenuItemCarryOver');
              localStorage.removeItem('readOnlyCategoryMenuItemCarryOverImg');
              setTimeout(function () {
                charleys_hide_overloading();
              }, 500);
            }
          }
          //end of read only menu forwarding



          if (editBasketItem) {
            // open Product to edit
            $(
              "button.menu-item-selector[data-menu-selection-id=" +
              editBasketProduct +
              "]"
            ).click();
          }

          if (editBasketItem == 0 && editBasketProduct > 0) {
            $(
              "button.menu-item-selector[data-menu-selection-id=" +
              editBasketProduct +
              "]"
            ).click();
          }
        },
        complete: function () {
          charleys_hide_loading();
          $(".wf-ordering-menu").removeClass("hide");
        },
      });

      // Add Menu Selections To Cart
      $("button#item-add-to-cart:not(:disabled)").click(function () {
        // alert('Add To Cart');
        addItemToBasket();
      });

      // Update edited basket product
      $("button#item-add-to-cart-update:not(:disabled)").click(function () {
        // Update Cart Product
        updateItemInBasket();
      });

      setGoogleReferral();
    })
    .hide()
    .fadeIn(transitionDuration);
}
//backwards compatibility work--cen remove later
let backwardsCompatibility = false;
function setItemOptions(group) {
  backwardsCompatibility = false;
  // end backwards compatibility work--cen remove later

  var $ = jQuery;
  var fieldsetLegend = group.description;
  // console.log('legend', fieldsetLegend);

  var $groupTemplate = $("[data-product-option-group].hide").clone();

  // $groupTemplate.find('[data-product-option-group-description]').text(group.description);

  // Modifier ID (option id)
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-chainmodifierid", group.chainmodifierid);
  // OLO: If the value is true, the user must select one and only one of the options in the group (e.g. true = radio buttons; false = checkboxes). Please reference this attribute before considering any of the other attributes listed below.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-mandatory", group.mandatory);
  // OLO: If the value is true, the user may select multiple quantities of any option they choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-supportschoicequantities", group.supportschoicequantities);
  // OLO: The minimum number of distinct options that the user must choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-minselects", group.minselects);
  // OLO: The maximum number of distinct options that the user may choose.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-maxselects", group.maxselects);
  // OLO: The minimum quantity for each choice the user selects.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-minchoicequantity", group.minchoicequantity);
  // OLO: The maximum quantity for each choice the user selects.
  $groupTemplate
    .find("[data-product-options]")
    .attr("data-maxchoicequantity", group.maxchoicequantity);

  $groupTemplate
    .find("[data-product-options]")
    .attr("data-choicequantityincrement", group.choicequantityincrement);

  var selectMin = 0;
  var selectMax = 0;

  var isValid = true;
  var isRequired = false;

  if (group.explanationtext) {
    fieldsetLegend += '<span class="explanationtext">' + group.explanationtext + '</span>';
  }

  if (
    (group.mandatory ||
      (group.minselects && group.minselects > 0) ||
      (group.minchoicequantity !== "" && group.minchoicequantity > 0)) && (!fieldsetLegend.includes('Ingredients'))
  ) {
    isValid = false;
    isRequired = true;
  }

  $groupTemplate.find("[data-product-options]").attr("data-is-valid", isValid);
  if (isRequired) {
    $groupTemplate
      .find("[data-product-options]")
      .attr("data-is-required", isRequired);
  }

  if (group.minchoicequantity > selectMin) {
    selectMin = group.minchoicequantity;
  }
  if (group.maxchoicequantity > selectMax) {
    selectMax = group.maxchoicequantity;
  }

  if (group.minselects > selectMin) {
    selectMin = group.minselects;
  }
  if (group.maxselects > selectMax) {
    selectMax = group.maxselects;
  }

  if (selectMin > 0 && selectMax > 0) {
    fieldsetLegend +=
      "<span>Select between " + selectMin + " and " + selectMax + "</span>";
  }

  if (isRequired) {
    fieldsetLegend += "<span data-mandatory-label></span>";
  }

  $groupTemplate
    .find("[data-product-options] legend[data-item-selector]")
    .html(fieldsetLegend);

  // console.log(group);
  //add classes for CSS customization
  if (fieldsetLegend.includes('Combo')) {
    $groupTemplate
      .find("[data-product-options]").addClass('highlight');

      $('.right-col').addClass('combo-meal');  

    // $('.product-detail-view-wrap').find(".combo-popup-alert").removeClass('hide');
    // setTimeout(function () {
    //   $('.product-detail-view-wrap').addClass('show-combo-popup-alert');
    // }, 200); // 200ms delay
  }
  if (fieldsetLegend.includes('Chef-Inspired Bold Flavors')) {
    $groupTemplate
      .find("[data-product-options]").addClass('wings-flavor-selector');
  }
  if (fieldsetLegend.includes('Size')) { 
    $groupTemplate
      .find("[data-product-options]").addClass('size-selector');
  }
  if (fieldsetLegend.includes('Add Ons')) {
    $groupTemplate
      .find("[data-product-options]").addClass('add-ons');
  }

  //end
  // Set up options
  $.each(group.options, function (index, option) {
    var $optionField = $groupTemplate
      .find("[data-product-option].hide")
      .clone();
    //
    if (option.images && option.images.length > 0) {

      let image = $('img[data-menu-item-detail-image]');
      let src = image.attr('src');
      let domain = new URL(src).hostname;
      // console.log('domain', domain);
      if (domain.includes('charleys.com')) {
        domain = 'olo-images-live.imgix.net';
      }
      let fileName = 'https://' + domain + '/' + option.images[0].filename;

      $optionField
        .find("label")
        .css('background-image', 'url(' + fileName + ')').css('padding-left', '74px').css('border-radius', '0').css('min-height', '40px');
    }
    //
    $optionField.find("input[data-item-selector]").attr("id", option.id);
    $optionField
      .find("input[data-item-selector]")
      .attr("data-chainoptionid", option.chainoptionid);

    $optionField
      .find("input[data-item-selector]")
      .attr("data-available-now", option.availability.now);

    $optionField
      .find("input[data-item-selector]")
      .attr("name", "select-" + group.chainmodifierid);

    $optionField.find("input[data-item-selector]").attr("data-cost", option.cost);
    $optionField.find("input[data-item-selector]").attr("data-calories", option.basecalories);
    $optionField.find("label[data-item-selector]").attr("for", option.id);

    $optionField.find("[data-info]").attr("data-option-id", option.id);

    if (group.mandatory || (group.maxselects == 1 && fieldsetLegend.includes('Side'))) {
      $optionField.find("input").attr("type", "radio");
    }


    if (group.supportschoicequantities) {
      // console.log('group.maxchoicequantity', group.maxchoicequantity);
      if (Number(group.maxchoicequantity) > 2) {
        // console.log('data-qty-select', $optionField.find('[data-qty-select]'));
        setQuantityElem(
          $optionField.find("[data-qty-select]"),
          group.minchoicequantity,
          group.maxchoicequantity,
          group.choicequantityincrement
        );
        $optionField
          .find("[data-qty-select] input")
          .attr("data-qty-for", option.id);

        $optionField
          .find("[data-qty-select] input")
          .attr("id", "item-qty-" + option.id);
        $optionField
          .find("[data-qty-select] label")
          .attr("for", "item-qty-" + option.id);

        $optionField
          .find("[data-qty-select]")
          .attr("data-qty-container-for", option.id);
        $optionField.find("[data-qty-select]").removeClass("hide");
        $optionField.find("[data-qty-select-simple]").remove();
      } else {
        $optionField
          .find("[data-qty-select-simple] input")
          .attr("data-qty-for", option.id);
        $optionField
          .find("[data-qty-select-simple]")
          .attr("data-qty-container-for", option.id);

        $optionField
          .find('[data-qty-select-simple] input[id="item-qty-1"]')
          .attr("id", "item-qty-1-" + option.id);
        $optionField
          .find('[data-qty-select-simple] label[for="item-qty-1"]')
          .attr("for", "item-qty-1-" + option.id);

        $optionField
          .find('[data-qty-select-simple] input[id="item-qty-2"]')
          .attr("id", "item-qty-2-" + option.id);
        $optionField
          .find('[data-qty-select-simple] label[for="item-qty-2"]')
          .attr("for", "item-qty-2-" + option.id);

        $optionField
          .find(
            '[data-qty-select-simple] input[id="item-qty-1-' + option.id + '"]'
          )
          .prop("checked", true);
        $optionField
          .find(
            '[data-qty-select-simple] input[id="item-qty-1-' + option.id + '"]'
          )
          .attr("name", "item-qty-option-" + option.id);
        $optionField
          .find(
            '[data-qty-select-simple] input[id="item-qty-2-' + option.id + '"]'
          )
          .attr("name", "item-qty-option-" + option.id);

        $optionField.find("[data-qty-select-simple]").removeClass("hide");
        $optionField.find("[data-qty-select]").remove();
      }
    } else {
      $optionField.find("[data-qty-select]").remove();
      $optionField.find("[data-qty-select-simple]").remove();
    }

    // Build the label
    // Select defualt options
    if (
      option.isdefault === true
    ) {
      $optionField.find("input[type='radio']").attr('radiodefualtcheckedstate', 'true');
      $optionField.find("input[type='radio']").parent().addClass('selected');

    }
    var labelText =
      "<span data-image></span><strong>" + option.name + "</strong>";

    //
    // console.log('combo',fieldsetLegend);
    if (
      option.name.includes("20 pc Boneless Wings") ||
      option.name.includes("30 pc Classic Wings") ||
      option.name.includes("30 pc Boneless Wings") ||
      // option.name.includes("6 pc Boneless & Fries") || 
      option.name.includes("6pc Boneless Wings") ||
      option.name.includes("6pc Classic Wings") ||
      option.name.includes("10 pc Boneless Wings") || 
      option.name.includes("10 pc Classic Wings") 
    ) {
      $('.right-col').addClass('formatting-30-50-pc-wings');

    }
    if (fieldsetLegend.includes("Big Game Bundle Wings")) {
      $('.right-col').addClass('formatting-big-game-bundle').addClass('formatting-add-accordian');
    }
    if (option.name.includes("50 pc Boneless Wings") ||
      option.name.includes("50 pc Classic Wings")) {
      $('.right-col').addClass('formatting-30-50-pc-wings formatting-30-50-pc-wings-with-s'); 
    }

    if (
      fieldsetLegend.includes("Cheesesteak Choice") || fieldsetLegend.includes("Crispy Chicken Choice")
    ) {
      $('.right-col').addClass('formatting-classic-combo-cheesesteak').addClass('formatting-classic-combo').addClass('formatting-add-accordian');
    }
    if (
      fieldsetLegend.includes("Wing Count")
    ) {
      $('.right-col').addClass('formatting-classic-combo-wings').addClass('formatting-classic-combo').addClass('formatting-add-accordian');
    }
    if (fieldsetLegend.includes("Select Drink - Add on")) {
      $('.right-col').addClass('formatting-classic-combo-drink-addon');
    }
    //

    var labelCost = "";
    if (option.cost) {
      labelCost += '<span>$' + formatMoney(option.cost) + '</span>';
      labelText += labelCost;
    }

    var labelCalories = "";
    if (option.basecalories) {
      labelCalories = option.basecalories;
    }
    if (option.maxcalories) {
      if (option.caloriesseparator && labelCalories.length) {
        labelCalories += " " + option.caloriesseparator + " ";
      }
      labelCalories += option.maxcalories;
    }

    if (labelCalories.length) {
      labelCalories += " Cal";
      if (option.cost) {
        labelText += "<span data-calories class='cal-left-margin'> " + labelCalories + "</span>";

      } else {
        labelText += "<span data-calories> " + labelCalories + "</span>";

      }
    } else {
      labelText += "<span data-calories></span>";
    }

    if (
      "info" in option &&
      "spicy" in option.info &&
      option.info.spicy !== "0" &&
      option.info.spicy !== null
    ) {
      labelText +=
        '<span data-spicy="' +
        option.info.spicy +
        '" title="Spicy Level is ' +
        option.info.spicy +
        ' out of 5" aria-label="Spicy Level is ' +
        option.info.spicy +
        ' out of 5">';
      for (i = 0; i < Number(option.info.spicy); i++) {
        labelText += '<i class="fa-solid fa-pepper-hot"></i>';
      }
      for (i = Number(option.info.spicy); i < 5; i++) {
        labelText += '<i class="fa-solid fa-pepper-hot gray"></i>';
      }
      labelText += "</span>";
      // console.log(option.name, option.info.spicy);
    }

    $optionField.find("label[data-item-selector]").html(labelText);

    if ("info" in option) {

      if (option.info.has_description) {
        $optionField
          .find("[data-info]")
          .attr("data-ingredient-id", option.info.post_id);
      } else {
        $optionField.find("[data-info]").remove();
      }
      if (
        option.info.calories.length &&
        $optionField.find("[data-calories]").text().length == 0
      ) {
        $optionField
          .find("[data-calories]")
          .html(option.info.calories);
      }
    } else {
      $optionField.find("[data-info]").remove();
    }

    $optionField.removeClass("hide");

    $groupTemplate.find("[data-product-options]").append($optionField);
    // console.log('i exist', fieldsetLegend);
    if (fieldsetLegend.includes('Side') || fieldsetLegend.includes('Drink') || fieldsetLegend.includes('Wing Count')) {
      $groupTemplate
        .find("[data-product-options]").addClass('wings-side-selector');
    }
    if (fieldsetLegend.includes('Wing Count')) {
      $groupTemplate
        .find("[data-product-options]").addClass('cheesesteak-size-selector');
    }
    if (fieldsetLegend.includes('Wing Count')) {
      // console.log('i exist', fieldsetLegend);
      setItemModifiers(option, $groupTemplate, prepend = false, isSecondEach = false, modifierLevel = 0, wingOption = true, wingsComboOption = true);
    } else if ((fieldsetLegend.includes('Side') && !fieldsetLegend.includes('Select')) || fieldsetLegend.includes('Select Size') || fieldsetLegend.includes('Select Drink') || fieldsetLegend.includes('Drink')) {
      $groupTemplate
        .find("[data-product-options]").addClass('wings-side-selector');
      setItemModifiers(option, $groupTemplate, prepend = false, isSecondEach = false, modifierLevel = 0, wingOption = true);

    }
    else if (fieldsetLegend.includes('Options') && !fieldsetLegend.includes('Add Ons')) {
      $groupTemplate
        .find("[data-product-options]").addClass('topping-selector-first-layer').addClass('topping-selector');
      comboDrinksModifiersToppingsConditionalSelector = true;
      drinksModifiersToppingsConditionalSelector = true;
      // console.log('fieldsetLegend1', fieldsetLegend);
      setItemModifiers(option, $groupTemplate, prepend = false, isSecondEach = false, modifierLevel = 0, wingOption = true, wingsComboOption = false, sidesModifiersToppingsConditionalSelector = true, drinksModifiersToppingsConditionalSelector = true);

    }
    else if (fieldsetLegend.includes('Remove')) {
      $groupTemplate
        .find("[data-product-options]").addClass('remove-selector');
    } else if (fieldsetLegend.includes('Cheesesteak') || (fieldsetLegend.includes('Wing Count')) || (fieldsetLegend.includes('Crispy Chicken Choice')) ) {
      $groupTemplate
        .find("[data-product-options]").addClass('cheesesteak-size-selector');
      setItemModifiers(option, $groupTemplate);
    } else {
      setItemModifiers(option, $groupTemplate);
    }
  }); // $.each(group.options ...

  $groupTemplate.removeClass("hide");
  $groupTemplate.find("input").attr("tabindex", "0");

  $("#product-detail-view .product-option-wrap").append($groupTemplate);
} // setItemOptions(options, $groupTemplate, group)
var counter = 0;

let selectSideID = [];
let selectDrinkID = [];
let selectIngredientsID = [];
function setItemModifiers(option, $groupTemplate, prepend = false, isSecondEach = false, modifierLevel = 0, wingOption = false, wingsComboOption = false, sidesModifiersToppingsConditionalSelector = false, comboDrinksModifiersToppingsConditionalSelector = false) {
  //
  var $ = jQuery;
  // Set Modifiers
  $.each(option.modifiers, function (index, modifier) {
    let fieldsetLegend = modifier.description;
    let modifierID = modifier.id;



    //conidtional selectors
    let justSidesConditionalSelector = fieldsetLegend.includes('Select Side');
    let sidesModifiersConditionalSelector = false;
    let sidesModifiersToppingsChildConditionalSelector = false;
    let comboDrinksModifiersToppingsChildConditionalSelector = false;
    let drinksModifiersToppingsChildConditionalSelector = false;
    let justDrinksConditionalSelector = fieldsetLegend.includes('Select Drink');
    let drinksModifiersConditionalSelector = false;

    let justIngredientsConditionalSelector =
      (fieldsetLegend.includes('Extras') && !isSecondEach && !wingOption && !selectDrinkID.includes(option.id) && (modifier.options.length > 1))
      ||
      (fieldsetLegend.includes('Remove') && !isSecondEach && !wingOption && !selectDrinkID.includes(option.id) && (modifier.options.length > 1))
      ||
      ((fieldsetLegend.includes('Toppings') || fieldsetLegend.includes('Ingredients')) && !selectSideID.includes(option.id) && !selectDrinkID.includes(option.id) && !wingOption && !wingsComboOption);

    let ingredientsModifiersConditionalSelector = false;
    let nestTheseModifiersConditionalSelector = false;

    //end of conditional selectors

    function collectModifierIds(options, idArray) {
      options.forEach(option => {
        idArray.push(option.id); // Add the id to the appropriate array

        if (option.modifiers) {
          collectModifierIds(option.modifiers, idArray);
        }
        if (option.options) {
          collectModifierIds(option.options, idArray);
        }
      });
    }

    let idArray;

    if (justSidesConditionalSelector) {
      // console.log('ahhh', fieldsetLegend);
      $modifierGroup = $groupTemplate
        .find("[combo-side-selection-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('side-modifier-parents');
      idArray = [];
      collectModifierIds(modifier.options, idArray);
      selectSideID = idArray;
    } else if (justDrinksConditionalSelector) {
      $modifierGroup = $groupTemplate
        .find("[combo-drink-selection-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('drink-modifier-parents');
      idArray = [];
      collectModifierIds(modifier.options, idArray);
      selectDrinkID = idArray;
    }
    else if (justIngredientsConditionalSelector) {
      // console.log('wingOption!!', wingOption);

      var $modifierGroup = $groupTemplate
        .find("[main-ingredient-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('ingredient-modifier-parents');

      idArray = [];
      collectModifierIds(modifier.options, idArray);
      selectIngredientsID = idArray;
      // console.log('selectIngredientsID', selectIngredientsID);
      // if (modifier.name === 'Salt') {
      //   console.log('i am salt')
      // }
    }
    else if (selectSideID.includes(modifier.id)) {
      // console.log('justSidesConditionalSelector #2', modifier.description, modifier.id);

      var $modifierGroup = $groupTemplate
        .find("[combo-side-selection-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('side-modifier-children');
      sidesModifiersConditionalSelector = true;
      if (fieldsetLegend.includes('Size')) {
        $modifierGroup.addClass('side-modifier-children-size-selector');
      }
    }
    else if (selectDrinkID.includes(modifier.id)) {
      var $modifierGroup = $groupTemplate
        .find("[combo-drink-selection-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('drink-modifier-children');
      if (fieldsetLegend.includes('Select Soft Drink')) {
        $modifierGroup.addClass('drink-modifier-children soft-drink');
      } else if (fieldsetLegend.includes('Size')) {
        $modifierGroup.addClass('side-modifier-children-size-selector');
      } else {
        $modifierGroup.addClass('drink-modifier-children');
      }
      drinksModifiersConditionalSelector = true;
    }
    else if (selectIngredientsID.includes(modifier.id) && !wingOption && !wingsComboOption) {
      var $modifierGroup = $groupTemplate
        .find("[main-ingredient-customizer-information-popup].hide")
        .clone();
      $modifierGroup.addClass('ingredient-modifier-children');

      ingredientsModifiersConditionalSelector = true;
      // if (modifier.name === 'Salt') {
      //   console.log('i am salt')
      // }
    }
    else {
      var $modifierGroup = $groupTemplate
        .find("[data-modifier-group].hide")
        .clone();
      //add conditional classes for styling

      if (fieldsetLegend.includes('Add Ons')) {
        $modifierGroup.addClass('add-ons');
      }
      if (fieldsetLegend.includes('Size') || fieldsetLegend.includes('Classic Wings') || fieldsetLegend.includes('Boneless Wings')) {
        $modifierGroup.addClass('size-selector');
      }

      if (fieldsetLegend.includes('Ice Options')) {
        $modifierGroup.addClass('ice-options-selector');
      }
    }
    // selection limiters
    if (modifier.minselects != null) {
      $modifierGroup.attr("data-minselects", modifier.minselects);
    }
    if (modifier.maxselects != null) {
      $modifierGroup.attr("data-maxselects", modifier.maxselects);
    }
    if (modifier.minchoicequantity != null && !modifier.minchoicequantity === "") {
      $modifierGroup.attr("data-minchoicequantity", modifier.minchoicequantity);
    }
    if (modifier.maxchoicequantity != null && !modifier.maxchoicequantity === "") {
      $modifierGroup.attr("data-maxchoicequantity", modifier.maxchoicequantity);
    }
    if (modifier.choicequantityincrement != null && !modifier.choicequantityincrement === "") {
      $modifierGroup.attr("data-choicequantityincrement", modifier.choicequantityincrement);
    }
    //
    var selectMin = 0;
    var selectMax = 0;
    if (modifier.minchoicequantity > selectMin) {
      selectMin = modifier.minchoicequantity;
    }
    if (modifier.maxchoicequantity > selectMax) {
      selectMax = modifier.maxchoicequantity;
    }
    if (modifier.minselects > selectMin) {
      selectMin = modifier.minselects;
    }
    if (modifier.maxselects > selectMax) {
      selectMax = modifier.maxselects;
    }
    if (selectMin > 0 && selectMax > 0) {
      fieldsetLegend +=
        "<span>Select between " + selectMin + " and " + selectMax + "</span>";
    }
    //end of selection limiters
    if (fieldsetLegend.includes('Side')) {
      $modifierGroup.addClass('wings-side-selector');
    }
    if (fieldsetLegend.includes('Combo')) {
      //backwards compatibility work--cen remove later
      $groupTemplate.find("[data-modifier-groups]").addClass('changeComboOrder');
      // end backwards compatibility work--cen remove later

      $modifierGroup.addClass('highlight');
      $('.right-col').addClass('combo-meal');  

      backwardsCompatibility = true;

      // $('.product-detail-view-wrap').find(".combo-popup-alert").removeClass('hide');
      // setTimeout(function () {
      //   $('.product-detail-view-wrap').addClass('show-combo-popup-alert');

      // }, 200); // 200ms delay
    }
    if (fieldsetLegend.includes('Chef-Inspired Bold Flavors')) {
      $modifierGroup.addClass('wings-flavor-selector');
    }
    if (fieldsetLegend.includes('Extras')) {
      $modifierGroup.addClass('extra-selector');
    } else if (fieldsetLegend.includes('Remove')) {
      $modifierGroup.addClass('remove-selector');
    } else if (fieldsetLegend.includes('Topping') || fieldsetLegend.includes('Ingredients')) {
      $modifierGroup.addClass('topping-selector');
      sidesModifiersToppingsConditionalSelector = true;

    } else if ((fieldsetLegend.includes('Options') && !fieldsetLegend.includes('Ice')) && !fieldsetLegend.includes('Add Ons')) {
      $modifierGroup.addClass('topping-selector');
      comboDrinksModifiersToppingsConditionalSelector = true;
      drinksModifiersToppingsConditionalSelector = true;
    }
    else {
      if (sidesModifiersToppingsConditionalSelector) {
        // console.log('fieldsetLegend1', fieldsetLegend);
        sidesModifiersToppingsChildConditionalSelector = true;
      }
      if (comboDrinksModifiersToppingsConditionalSelector) {
        comboDrinksModifiersToppingsChildConditionalSelector = true;
        drinksModifiersToppingsChildConditionalSelector = true;
        // console.log('fieldsetLegend2', fieldsetLegend);

      }
    }
    $modifierGroup.attr("data-modifier-for", option.id);
    $modifierGroup.attr("data-modifier-id", modifierID);


    var isValid = true;
    var isRequired = false;

    if (modifier.explanationtext) {
      fieldsetLegend += '<span class="explanationtext">' + modifier.explanationtext + '</span>';
    }

    if (
      (modifier.mandatory ||
        (modifier.minselects && modifier.minselects > 0) ||
        (modifier.minchoicequantity !== "" && modifier.minchoicequantity > 0)) && (!fieldsetLegend.includes('Ingredients'))
    ) {
      isValid = false;
      isRequired = true;
    }

    $modifierGroup.attr("data-is-valid", isValid);
    if (isRequired) {
      $modifierGroup.attr("data-is-required", isRequired);
    }

    if (isRequired) {
      fieldsetLegend += "<span data-mandatory-label class='secondary-mandatory-label'></span>";
    }

    $modifierGroup.find("legend").html(fieldsetLegend);

    $.each(modifier.options, function (index, m_option) {
      // console.log('m_option.name ', m_option.name, m_option.id);
      if (justSidesConditionalSelector || selectSideID.includes(m_option.id)) {
        // console.log('#2');
        var $m_optionField = $modifierGroup
          .find("[data-product-option-modifier-option-for-combo-side-selection].hide")
          .clone();

        sidesModifiersConditionalSelector = true;

        // console.log('m_option', m_option.name, m_option.id);
      }
      else if (justDrinksConditionalSelector || selectDrinkID.includes(m_option.id)) {
        // console.log('#3');
        var $m_optionField = $modifierGroup
          .find("[data-product-option-modifier-option-for-combo-drink-selection].hide")
          .clone();
        drinksModifiersConditionalSelector = true;

        // console.log('selectSideID:', selectDrinkID);
      }
      else if ((justIngredientsConditionalSelector && !wingOption && !wingsComboOption) || (selectIngredientsID.includes(m_option.id) && !wingOption && !wingsComboOption)) {
        // console.log('#3');
        var $m_optionField = $modifierGroup
          .find("[data-product-option-modifier-option-for-ingredient-selection].hide")
          .clone();
        ingredientsModifiersConditionalSelector = true;


        // console.log('selectIngredientsID:', m_option.name, m_option.id, option.name);
      }
      // else if (
      //   // (fieldsetLegend.includes('Toppings') || fieldsetLegend.includes('Ingredients')) ||
      //   // (modifier.options
      //   //   && modifier.options.length > 1
      //   //   && modifierLevel === 1
      //   //   && !wingsComboOption
      //   //   && !fieldsetLegend.includes('Toppings')
      //   //   && !fieldsetLegend.includes('Ingredients')
      //   //   && !fieldsetLegend.includes('Add Ons')
      //   //   && !fieldsetLegend.includes('Select Soft Drink')
      //   //   && !fieldsetLegend.includes('Lemonade')
      //   //   && !fieldsetLegend.includes('Side')
      //   // )
      //   (fieldsetLegend.includes('Options') && !fieldsetLegend.includes('Add Ons')) 
      // ) {
      //   // console.log('Im more!!', fieldsetLegend, m_option.name, m_option.id, option.name);
      //   var $m_optionField = $modifierGroup
      //     .find("[data-product-option-modifier-option].hide")
      //     .clone();
      //   nestTheseModifiersConditionalSelector = true;
      //   $modifierGroup.addClass('all-other-nested-selector');
      // }

      else {
        // console.log('Im more', fieldsetLegend, m_option.name, m_option.id, option.name, modifierLevel, wingOption);

        // console.log('#4');
        var $m_optionField = $modifierGroup
          .find("[data-product-option-modifier-option].hide")
          .clone();
        $m_optionField.addClass('all-other-modifier-children');

      }
      //
      if (m_option.images && m_option.images.length > 0) {

        let image = $('img[data-menu-item-detail-image]');
        let src = image.attr('src');
        let domain = '';
        let fileName = '';

        if (typeof src !== typeof undefined && src !== false) {
          let domain = new URL(src).hostname;
          // console.log('domain', domain);
          if (domain.includes('charleys.com')) {
            domain = 'olo-images-live.imgix.net';
          }
          fileName = 'https://' + domain + '/' + m_option.images[0].filename;

          $m_optionField
            .find("label")
            .css('background-image', 'url(' + fileName + ')').css('padding-left', '74px').css('border-radius', '0').css('min-height', '40px');
        }
      }
      //

      $m_optionField.find("input").attr("id", m_option.id);
      $m_optionField
        .find("input")
        .attr("data-chainoptionid", m_option.chainoptionid);

      $m_optionField
        .find("input")
        .attr('data-modifier-level', modifierLevel);

      $m_optionField
        .find("input")
        .attr('data-option-for-modifier', modifierID);

      $m_optionField
        .find("input")
        .attr("data-available-now", m_option.availability.now);

      $m_optionField.find("input").attr("name", "select-" + modifierID);
      $m_optionField.find("input").attr("data-cost", m_option.cost);
      $m_optionField.find("input").attr("data-calories", m_option.maxcalories);

      $m_optionField.find("label").attr("for", m_option.id);

      if (
        (modifier.mandatory && !justIngredientsConditionalSelector && !justSidesConditionalSelector && !justDrinksConditionalSelector)
        || (modifier.maxselects == 1 && fieldsetLegend.includes('Side') && !justIngredientsConditionalSelector && !justSidesConditionalSelector && !justDrinksConditionalSelector && !fieldsetLegend.includes('Dipping Side'))
      ) {
        $m_optionField.find("input").attr("type", "radio");
      }
      // select defualt options
      if (m_option.name.includes('Place on the Side')) {
        $m_optionField.addClass('placeOnSideSelector');
      }
      // if ((selectSideID.includes(m_option.id) && (m_option.name.includes('Salt'))) || (selectDrinkID.includes(m_option.id) && (m_option.name.includes('Ice')))) {
      //   $m_optionField.addClass('maybeHideThisFieldset');
      //   $m_optionField.find("input").attr('radiodefualtcheckedstate', 'true');
      // }
      //
      if (m_option.isdefault === true) {
        $m_optionField.find("input").attr('radiodefualtcheckedstate', 'true');
      }
      var labelText = "<span data-image></span><strong>" + m_option.name + "</strong>";

      // end of select defualt options

      var labelCost = "";
      if (m_option.cost) {
        labelCost += "+$" + formatMoney(m_option.cost);
        labelText += labelCost;
      }

      var labelCalories = "";
      if (m_option.maxcalories && (m_option.basecalories !== null && m_option.basecalories !== "")) {
        labelCalories = m_option.basecalories + '-' + m_option.maxcalories;
      } else if (m_option.maxcalories) {
        labelCalories = m_option.maxcalories;
        $m_optionField.find("input").attr("data-calories", labelCalories);
      } else if (m_option.basecalories !== null && m_option.basecalories !== "") {
        labelCalories = m_option.basecalories;
        $m_optionField.find("input").attr("data-calories", labelCalories);

      }

      if (labelCalories.length) {
        labelCalories += " Cal";
        if (m_option.cost) {
          labelText += "<span data-calories class='cal-left-margin'> " + labelCalories + "</span>";
        } else {
          labelText += "<span data-calories> " + labelCalories + "</span>";
        }
      } else {
        // hide calories if there are none
        // labelText += '<span data-calories></span>';
      }

      if (
        "info" in m_option &&
        "spicy" in m_option.info &&
        m_option.info.spicy !== "0" &&
        m_option.info.spicy !== null
      ) {
        labelText +=
          '<span data-spicy="' +
          m_option.info.spicy +
          '" title="Spicy Level is ' +
          m_option.info.spicy +
          ' out of 5" aria-label="Spicy Level is ' +
          m_option.info.spicy +
          ' out of 5">';
        for (i = 0; i < Number(m_option.info.spicy); i++) {
          labelText += '<i class="fa-solid fa-pepper-hot"></i>';
        }
        for (i = Number(m_option.info.spicy); i < 5; i++) {
          labelText += '<i class="fa-solid fa-pepper-hot gray"></i>';
        }
        labelText += "</span>";
        // console.log(m_option.name, m_option.info.spicy);
      }

      $m_optionField.find("label").html(labelText);

      if ("info" in m_option) {
        // console.log('option info: ', option.info, $optionField.find('[data-image]'));
        if (m_option.info.image_url.length) {
          $m_optionField.find("[data-image]").css({
            "background-image": "url(" + m_option.info.image_url + ")",
          });
        }
        $m_optionField
          .find("[data-info]")
          .attr("data-ingredient-id", m_option.info.post_id);
        if (m_option.info.has_description) {
          $m_optionField
            .find("[data-info]")
            .attr("data-ingredient-id", m_option.info.post_id);
        } else {
          $m_optionField.find("[data-info]").remove();
        }

        if (
          m_option.info.calories.length &&
          $m_optionField.find("[data-calories]").text().length == 0
        ) {
          $m_optionField
            .find("[data-calories]")
            .html(m_option.info.calories);
        }
      } else {
        $m_optionField.find("[data-info]").remove();
      }

      $m_optionField.removeClass("hide");
      $modifierGroup.append($m_optionField);

    }); // $.each(modifier.options ...

    $modifierGroup.removeClass("hide");
    $modifierGroup.find("input").attr("tabindex", "0");

    if (justSidesConditionalSelector) {

      $groupTemplate.find("[data-modifier-groups-for-combo-side-selection]").append($modifierGroup);
    }
    else if (justDrinksConditionalSelector) {
      $groupTemplate.find("[data-modifier-groups-for-combo-drink-selection]").append($modifierGroup);
    }
    else if (justIngredientsConditionalSelector) {
      $groupTemplate.find("[data-modifier-groups-for-ingredient-customizer]").append($modifierGroup);
    }
    else if (sidesModifiersConditionalSelector) {
      sideLabelId = option.id;
      sideLabelIdNested = modifier.id;
      if (backwardsCompatibility || (modifierLevel === 1)) {

        let sideCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-side-selection] fieldset label[for='${sideLabelId}']`);
        let sideDirectParent = sideCorrispondingLabel.parent();

        $groupTemplate.find(sideDirectParent).append($modifierGroup);
      } else {
        if (sidesModifiersToppingsChildConditionalSelector) {

          let sideCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-side-selection] fieldset label[for='${sideLabelId}']`);
          let sideDirectParent = sideCorrispondingLabel.parent();

          $groupTemplate.find(sideDirectParent).append($modifierGroup);
        } else {

          let sideCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-side-selection] fieldset label[for='${sideLabelId}']`);
          // sideCorrispondingLabel.addClass('ahhhsdgsd');
          let sideDirectParent = sideCorrispondingLabel.parent().addClass('ahhh');
          // console.log('sideDirectParent', sideDirectParent.text());
          let sideDirectParentOfParent = sideDirectParent.parent();
          // console.log('sideDirectParentOfParent', sideDirectParentOfParent.text());

          $groupTemplate.find(sideDirectParentOfParent).append($modifierGroup);
        }

      }

    }
    else if (drinksModifiersConditionalSelector) {
      drinkLabelId = option.id;
      if ((modifierLevel === 1) || backwardsCompatibility) {
        let drinkCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-drink-selection] fieldset label[for='${drinkLabelId}']`);
        let drinkDirectParent = drinkCorrispondingLabel.parent();

        $groupTemplate.find(drinkDirectParent).append($modifierGroup);
      } else {
        if (comboDrinksModifiersToppingsChildConditionalSelector) {
          let drinkCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-drink-selection] fieldset label[for='${drinkLabelId}']`);
          let drinkDirectParent = drinkCorrispondingLabel.parent();

          $groupTemplate.find(drinkDirectParent).append($modifierGroup);
        } else {
          let drinkCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-combo-drink-selection] fieldset label[for='${drinkLabelId}']`);
          let drinkDirectParent = drinkCorrispondingLabel.parent();
          let drinkDirectParentOfParent = drinkDirectParent.parent();

          $groupTemplate.find(drinkDirectParentOfParent).append($modifierGroup);
        }

      }
    }

    else if (ingredientsModifiersConditionalSelector) {
      // console.log('asdgkjlasdgsdg');

      ingredientLabelId = option.id;
      let ingredientCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups-for-ingredient-customizer] fieldset label[for='${ingredientLabelId}']`);
      let ingredientDirectParent = ingredientCorrispondingLabel.parent();

      $groupTemplate.find(ingredientDirectParent).append($modifierGroup);
    }
    else if (sidesModifiersToppingsChildConditionalSelector) {
      // console.log('asdgkjlasdgsdg 2');

      allOtherLabelId = option.id;
      // console.log(fieldsetLegend, option.id, modifier.description, sidesModifiersToppingsConditionalSelector, nestTheseModifiersConditionalSelector); 

      let allOtherCorrispondingLabel = $groupTemplate.find(`fieldset.topping-selector label[for='${allOtherLabelId}']`);
      $(allOtherCorrispondingLabel);


      let allOtherDirectParent = allOtherCorrispondingLabel.parent();
      $(allOtherDirectParent).addClass('all-other-modifier-parents')

      $groupTemplate.find(allOtherDirectParent).append($modifierGroup);
    }
    else if (drinksModifiersToppingsChildConditionalSelector) {
      // console.log(fieldsetLegend, option.id, modifier.description, drinksModifiersToppingsChildConditionalSelector); 

      allOtherLabelId = option.id;
      // console.log(fieldsetLegend, option.id, modifier.description, sidesModifiersToppingsConditionalSelector, nestTheseModifiersConditionalSelector); 

      let allOtherCorrispondingLabel = $groupTemplate.find(`fieldset label[for='${allOtherLabelId}']`);
      $(allOtherCorrispondingLabel);


      let allOtherDirectParent = allOtherCorrispondingLabel.parent();
      $(allOtherDirectParent).addClass('all-other-modifier-parents')

      $groupTemplate.find(allOtherDirectParent).append($modifierGroup);
      // allOtherLabelId = option.id;

      // let allOtherCorrispondingLabel = $groupTemplate.find(`[data-modifier-groups] fieldset label[for='${allOtherLabelId}']`);
      // let allOtherDirectParent = allOtherCorrispondingLabel.parent();
      // $(allOtherDirectParent).addClass('all-other-modifier-parents')

      // $groupTemplate.find(allOtherDirectParent).append($modifierGroup);
      // $groupTemplate.find("[data-modifier-groups]").append($modifierGroup);

    }
    else {
      // console.log('ahhh');
      $groupTemplate.find("[data-modifier-groups]").append($modifierGroup);
    }

    $.each(modifier.options, function (index, m_option) {
      // Recurse modifier modifiers (lord lord)
      // console.log('wingOption', wingOption, fieldsetLegend, modifierLevel, wingsComboOption);
      if (m_option.modifiers) {
        setItemModifiers(m_option, $groupTemplate, false, true, modifierLevel + 1, wingOption, wingsComboOption, sidesModifiersToppingsConditionalSelector, comboDrinksModifiersToppingsConditionalSelector);
      }
    });


  }); // $.each(option.modifiers ...
} // setItemModifiers(m_group)

var $ = jQuery;

jQuery(document).ready(function ($) {

  // Popup functionality
  function toggleCustomizerPopup($parent, show) {
    // console.log('add classes');
    var $popup = $parent.find('.customizer-information-popup');
    var $overlay = $parent.find('[main-information-popup-overlay]');
    var $button = $parent.find('.customizer-information-popup-button');

    if ($popup.length) {
      if (show) {
        $popup.show().attr('aria-hidden', 'false');
        $button.attr('aria-expanded', 'true');
        $overlay.addClass('visible');

        $popup.find('.close-customizer-information-popup:not(.complex-price-button)').focus();
      } else {
        $popup.hide().attr('aria-hidden', 'true');
        $button.attr('aria-expanded', 'false');
        $button.focus();
        $overlay.removeClass('visible');
      }
    } else {
      // console.error("Pop-up element not found");
    }
  }

  function setupCustomizer(parentSelector) {
    function handlePopupToggle(event) {
      if (event.type === 'click' || event.type === 'keypress' && event.key === 'Enter') {
        let $parent = $(this).closest(parentSelector);
        // console.log('i clikcsssssssss', $parent);

        let safariOverlayFixSelector = $('.reveal-overlay.differnt-popup-overlay');
        $(safariOverlayFixSelector).addClass('safariOverlayFixSelector');

        toggleCustomizerPopup($parent, true);
      }
    }

    $(document).on('click keypress', parentSelector + ' .customizer-information-popup-button', handlePopupToggle);

    function handlePopupClose(event) {
      if (event.type === 'click' || event.type === 'keypress' && event.key === 'Enter') {
        let $parent = $(this).closest(parentSelector);
        let safariOverlayFixSelector = $('.reveal-overlay.differnt-popup-overlay');
        $(safariOverlayFixSelector).removeClass('safariOverlayFixSelector');

        toggleCustomizerPopup($parent, false);
      }
    }

    $(document).on('click keypress', parentSelector + ' .close-customizer-information-popup', handlePopupClose);


  }

  setupCustomizer('#main-ingredient-customizer-information-parent');
  setupCustomizer('#combo-side-selection-customizer-information-parent');
  setupCustomizer('#combo-drink-selection-customizer-information-parent');

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape') {
      toggleCustomizerPopup($('#main-ingredient-customizer-information-parent'), false);
      toggleCustomizerPopup($('#combo-side-selection-customizer-information-parent'), false);
      toggleCustomizerPopup($('#combo-drink-selection-customizer-information-parent'), false);
      let safariOverlayFixSelector = $('.reveal-overlay.differnt-popup-overlay');
      $(safariOverlayFixSelector).removeClass('safariOverlayFixSelector');
    }
  });
  // Close popup when clicking outside
  $(document).on('click', function (event) {
    if (!$(event.target).closest('.customizer-information-popup').length && !$(event.target).closest('.customizer-information-popup-button').length) {
      toggleCustomizerPopup($('#main-ingredient-customizer-information-parent'), false);
      toggleCustomizerPopup($('#combo-side-selection-customizer-information-parent'), false);
      toggleCustomizerPopup($('#combo-drink-selection-customizer-information-parent'), false);
      let safariOverlayFixSelector = $('.reveal-overlay.differnt-popup-overlay');
      $(safariOverlayFixSelector).removeClass('safariOverlayFixSelector');
    }
  });


  // New functionality: Add class 'open' to the clicked element
  $(document).on('click', '.right-col.formatting-add-accordian .product-option-wrap>div:not(.formatting-big-game-bundle .product-option-wrap>div:nth-of-type(8), .formatting-big-game-bundle .product-option-wrap>div:nth-of-type(5))', function (event) {
    let elementTop = $(this).offset().top;
    let clickPosition = event.pageY;

    // Check if the click happened within the top 70px of the element
    if (clickPosition <= elementTop + 70) {
      // console.log('open');
      // Remove 'open' class from other divs but not the clicked one
      
      $('.right-col.formatting-add-accordian .product-option-wrap>div').not(this).removeClass('open');

      if ($(this).is('.right-col.formatting-big-game-bundle .product-option-wrap>div:nth-of-type(4):not(.open)')) {
        $('.product-option-wrap>div:nth-of-type(5)').addClass('open');
      } else if ($(this).is('.formatting-big-game-bundle .product-option-wrap>div:nth-of-type(7):not(.open)')) {
        $('.product-option-wrap>div:nth-of-type(8)').addClass('open');

      }
      // Toggle 'open' class on the clicked element
      $(this).toggleClass('open');

      // If the element is now open, scroll to the top of it
      if ($(this).hasClass('open')) {
        let container = $('#product-detail-view');
        let scrollPosition = $(this).offset().top - container.offset().top + container.scrollTop();

        container.animate({
          scrollTop: scrollPosition
        }, 500); // 500ms for smooth scroll 
      } 
    }
  });
});
